module.exports = __webpack_public_path__ + "static/media/logo-white.00093955.svg";